/**
 * Intercom Fallback Handler
 * Detects when Intercom fails to load and shows a fallback contact option
 */
(function () {
  // Only run if intercomSettings exist
  if (!window.intercomSettings || !window.intercomSettings.app_id) {
    return;
  }

  // Get support email from data attribute
  const supportEmail = document.body.getAttribute('data-support-email');

  if (!supportEmail) {
    return;
  }

  let intercomLoadTimeout;
  let intercomLoadChecked = false;

  // Check if Intercom has loaded after a reasonable timeout
  function checkIntercomLoaded() {
    if (intercomLoadChecked) return;
    intercomLoadChecked = true;

    const intercomLoaded = typeof window.Intercom === 'function' && window.Intercom.booted !== undefined;

    if (!intercomLoaded) {
      showFallbackContact();
    }
  }

  // Create and show fallback contact button
  function showFallbackContact() {
    // Don't create if already exists
    if (document.getElementById('intercom-fallback')) {
      return;
    }

    const fallbackButton = document.createElement('div');
    fallbackButton.id = 'intercom-fallback';
    fallbackButton.className = 'intercom-fallback-button';
    fallbackButton.innerHTML = `
            <button class="fallback-launcher" onclick="window.openFallbackContact()" title="Contact Support">
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 9L14 16L24 9M4 9V19C4 19.5304 4.21071 20.0391 4.58579 20.4142C4.96086 20.7893 5.46957 21 6 21H22C22.5304 21 23.0391 20.7893 23.4142 20.4142C23.7893 20.0391 24 19.5304 24 19V9M4 9L6 7H22L24 9" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
        `;

    document.body.appendChild(fallbackButton);

    // Add slight delay before showing to avoid flash
    setTimeout(() => {
      fallbackButton.classList.add('show');
    }, 100);
  }

  // Global function to open fallback contact
  window.openFallbackContact = function () {
    const modal = document.createElement('div');
    modal.className = 'intercom-fallback-modal';

    modal.innerHTML = `
            <div class="fallback-modal-overlay" onclick="window.closeFallbackContact()"></div>
            <div class="fallback-modal-content">
                <button class="fallback-modal-close" onclick="window.closeFallbackContact()">&times;</button>
                <div class="fallback-modal-header">
                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 16L24 28L40 16M8 16V34C8 34.5304 8.21071 35.0391 8.58579 35.4142C8.96086 35.7893 9.46957 36 10 36H38C38.5304 36 39.0391 35.7893 39.4142 35.4142C39.7893 35.0391 40 34.5304 40 34V16M8 16L10 14H38L40 16" stroke="var(--primary-color)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <h3>Contact Support</h3>
                </div>
                <p class="fallback-modal-message">
                    Our chat service is temporarily unavailable. Please reach out to us directly:
                </p>
                <a href="mailto:${escapeHtml(supportEmail)}" class="fallback-email-link">
                    ${escapeHtml(supportEmail)}
                </a>
                <p class="fallback-modal-footer">
                    We'll get back to you as soon as possible!
                </p>
            </div>
        `;

    document.body.appendChild(modal);
    setTimeout(() => modal.classList.add('show'), 10);
  };

  // Global function to close fallback contact
  window.closeFallbackContact = function () {
    const modal = document.querySelector('.intercom-fallback-modal');
    if (modal) {
      modal.classList.remove('show');
      setTimeout(() => modal.remove(), 300);
    }
  };

  // Set timeout to check if Intercom loaded (10 seconds)
  intercomLoadTimeout = setTimeout(checkIntercomLoaded, 10000);

  // Also check on window load
  if (document.readyState === 'complete') {
    setTimeout(checkIntercomLoaded, 5000);
  } else {
    window.addEventListener('load', () => {
      setTimeout(checkIntercomLoaded, 5000);
    });
  }

  // Listen for errors loading the Intercom script
  window.addEventListener(
    'error',
    (e) => {
      if (e.target && e.target.src && e.target.src.includes('intercom.io')) {
        checkIntercomLoaded();
      }
    },
    true
  );
})();
